import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=7bd44e97&scoped=true&"
import script from "./Frame.vue?vue&type=script&lang=js&"
export * from "./Frame.vue?vue&type=script&lang=js&"
import style0 from "./Frame.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Frame.vue?vue&type=style&index=1&id=7bd44e97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd44e97",
  null
  
)

export default component.exports